import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
// @ts-ignore
import Captcha from 'captcha-mini';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent implements OnInit {
  @ViewChild('captchaCanvas', { static: true }) captchaCanvas!: ElementRef<HTMLCanvasElement>;
  captchaCode!: string;
  userInputCaptcha!: string;

  constructor() {}

  ngOnInit(): void {
    this.generateCaptcha();
  }

  generateCaptcha(): void {
    const captcha = new Captcha({
      lineWidth: 1,   // Largura das linhas de interferência
      lineNum: 3,     // Número de linhas de interferência
      dotR: 1,        // Raio dos pontos de interferência
      dotNum: 50,     // Número de pontos de interferência
      preGroundColor: [10, 80],  // Cor de primeiro plano
      backGroundColor: [150, 250], // Cor de fundo
      fontSize: 70,   // Tamanho da fonte
      fontFamily: ['Georgia', '微软雅黑', 'Helvetica', 'Arial'], // Fontes
      fontStyle: 'fill', // Estilo da fonte
      content: 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ23456789', // Conteúdo do captcha
      length: 4 // Comprimento do captcha
    });

    captcha.draw(this.captchaCanvas.nativeElement, (captchaText: string) => {
      // Aqui, `captchaText` é o texto correto gerado pelo captcha
      this.captchaCode = captchaText;
      // console.log('Código do Captcha: ', captchaText);
    });
  }

  // Função para recarregar o CAPTCHA, caso necessário
  reloadCaptcha(): void {
    this.generateCaptcha();
  }
}
